import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import './styles/address_field.scss';

import rollbarLogger from '../../utils/rollbarLogger';

export class CustomField extends React.Component {
  static MAP_CHILD = 'CHILD';
  static MAP_PARENTS = [...Array(4).keys()].map(i => `PARENT${i+1}`); // Parents are 1-indexed for some reason
  static MAP_SIBLINGS = [...Array(10).keys()].map(i => `SIBLING${i}`);
  static MAP_RELATIVES = [...Array(5).keys()].map(i => `RELATIVE${i}`);
  static MAP_CONSULTANT = 'CONSULTANT';

  static MAP_HOUSEHOLDS = [...Array(2).keys()].map(i => `HOUSEHOLD${i+1}`) ; // Also 1-indexed
  static MAP_SCHOOL_HISTORIES = [...Array(2).keys()].map(i => `SCHOOL_HISTORY${i+1}`) ; // Also 1-indexed

  static CONTACT_MAPPINGS = [
    CustomField.MAP_CHILD,
    ...CustomField.MAP_PARENTS,
    ...CustomField.MAP_SIBLINGS,
    ...CustomField.MAP_RELATIVES,
    CustomField.MAP_CONSULTANT,
  ];

  static MAPPINGS = [
    ...CustomField.CONTACT_MAPPINGS,
    ...CustomField.MAP_HOUSEHOLDS,
    ...CustomField.MAP_SCHOOL_HISTORIES
  ];

  static propTypes = {
    value: PropTypes.object,
    errors: PropTypes.object,
    map_to: PropTypes.oneOf(CustomField.MAPPINGS),
    field_name: PropTypes.string,
    required: PropTypes.bool,
    subfields: PropTypes.array,
    readonly: PropTypes.bool,

    parent: PropTypes.instanceOf(CustomField),

    edit: PropTypes.bool, // Whether to render the edit view or the display view.

    updateAnswer: PropTypes.func
  };

  static Subfield = ({prompt, hidden, className, required, dataFlavor, hasError, name, children}) => {
    const child = React.Children.only(children);
    return <div
      className={`sa-form-sub-field ${hidden ? 'hidden' : ''} ${className || ''} ${required ? 'sa-form-required-field required' : ''}`}
      data-flavor={dataFlavor}
      data-name={name}
    >
      {React.cloneElement(child, {
        className: `${child.props.className} ${required ? 'required' : ''}`,
        name
      })}
      <span className={'form-text'}>
        <label className={`sa-form-sub-field-label ${required ? 'sa-form-required-label required' : ''} ${hasError ? 'sa-form-error-field-label' : ''}`} htmlFor={name}>
          {prompt}
        </label>
      </span>
    </div>;
  };

  mappedFieldName() {
    if(this.props.parent) {
      return [this.props.parent.mappedFieldName(), this.props.field_name].filter(x=>x).join('_').toLowerCase();
    }
    else {
      return [this.props.map_to, this.props.field_name].filter(x=>x).join('_').toLowerCase();
    }
  }

  renderView() {
    rollbarLogger.error(`No renderView method for field ${this.constructor.name} ${this.mappedFieldName()}`, this.props);
    return <div>Unable to display field {this.mappedFieldName()}</div>
  }

  renderEdit() {
    rollbarLogger.error(`No renderEdit method for field ${this.constructor.name} ${this.mappedFieldName()}`, this.props);
    return <div>Unable to display field {this.mappedFieldName()}</div>
  }

  render() {
    const {
      edit,
      parent
    } = this.props;

    if (edit || (parent && parent.props.edit)) {
      return this.renderEdit();
    }
    else{
      return this.renderView();
    }
  }
}

export default CustomField;